import ghost from './ghost';
import ghostPrimary from './ghost-primary';
import link from './link';
import lowlight from './lowlight';
import muted from './muted';
import outline from './outline';
import regular from './regular';
import outlineAccent from './outline-accent';
export default {
  ghost,
  ghostPrimary,
  link,
  lowlight,
  muted,
  outline,
  regular,
  outlineAccent
};